import { Gray, Red, White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '10px',
  justifyContent: 'space-between',
  padding: '24px 24px',
  backgroundColor: Gray.Gray90,
  borderRadius: '8px'
});
export const column = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',
  width: '240px'
});
export const title = css({
  color: White.White10Alpha70,
  fontWeight: 500,
  fontSize: '20px'
});
export const content = css({
  color: White.White10,
  fontSize: '24px',
  fontWeight: 700
});
export const failed = css({
  color: Red.Red50
});
